/* eslint-disable no-extra-parens */
import { useEffect, useRef } from 'react';
import type { IStoreState } from '../../components/common/interfaces/types';
import { reduxConnect } from '../../common';

type BoltiveProps = {
    activeRoute: string;
    isBoltiveEnabledInFirebaseRemoteConfig: boolean;
    isBoltiveEnabled: boolean;
    boltiveConfiguredTestPage: string;
    boltiveClientId: string;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { appState, boltive } = storeState || {};
    const { boltiveConfig, activeRoute } = appState?.appState || {};
    const { IsEnabled: isBoltiveEnabled, SpecificPageRouteNameToEnableForQA: boltiveConfiguredTestPage, ClientId: boltiveClientId } = boltiveConfig || {};

    return {
        activeRoute,
        isBoltiveEnabledInFirebaseRemoteConfig: boltive.shouldLoadBoltiveTag,
        isBoltiveEnabled,
        boltiveConfiguredTestPage,
        boltiveClientId
    };
};

const mapDispatchToProps = {};

export const BoltiveLoader = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ 
    isBoltiveEnabled, 
    boltiveConfiguredTestPage, 
    boltiveClientId, 
    isBoltiveEnabledInFirebaseRemoteConfig, 
    activeRoute }: BoltiveProps) => {
    const isBoltiveScriptTagLoadedToDOM = useRef(false);

    useEffect(() => {
        if ((isBoltiveEnabled && activeRoute !== boltiveConfiguredTestPage) 
            || (!isBoltiveEnabled && activeRoute === boltiveConfiguredTestPage) 
            && isBoltiveEnabledInFirebaseRemoteConfig 
            && !isBoltiveScriptTagLoadedToDOM.current) {
            const boltiveScriptId = 'boltive-script-id';
            const boltiveScript = document.getElementById(boltiveScriptId);
            if (!boltiveScript && boltiveClientId) {
                const scriptTag = document.createElement('script');
                scriptTag.src = `https://tagan.adlightning.com/${boltiveClientId}/op.js`;
                scriptTag.defer = true;
                scriptTag.id = boltiveScriptId;
        
                scriptTag.onload = () => {
                    window.addEventListener('message', function (event) {
                        const data = event.data || {};
                        if (data.message === 'ADL_BLOCKED') {
                            console.log('WB_Boltive_Debug data: ', data);
                            console.log('WB_Boltive_Debug Ad Unit: ', data.adUnit);
                            console.log('WB_Boltive_Debug Ad server Details: ', data.adServerDetails);
                        }
                    });
                };
        
                scriptTag.onerror = () => {
                    console.error('Failed to load Boltive script tag');
                };
        
                document.head.appendChild(scriptTag);
                isBoltiveScriptTagLoadedToDOM.current = true;
            }
        }
    }, [isBoltiveEnabledInFirebaseRemoteConfig, boltiveClientId, boltiveConfiguredTestPage, isBoltiveEnabled, activeRoute]);

    return null;
});